// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-runtime-inspector {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 5003;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    pointer-events: none;
}

.survey-runtime-inspector-tab {
    pointer-events: all;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    background: var(--primary);
    color: #fff;
    border-radius: 0 4px 4px 0;
    padding: 12px 6px;
    cursor: pointer;
    font-size: 12px;
    font-family: Helvetica, Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.05em;
    white-space: nowrap;
    writing-mode: vertical-rl;
    text-orientation: mixed;
    transform: rotate(180deg);
    border: none;
    outline: none;
    user-select: none;
    box-shadow: -2px 0 6px rgba(0, 0, 0, 0.2);
}

.survey-runtime-inspector-tab:hover {
    background: var(--primary-hover);
}

.survey-runtime-inspector-panel {
    pointer-events: all;
    width: 300px;
    background: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-shadow: -3px 0 10px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.survey-runtime-inspector-panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border-bottom: 1px solid #e5e5e5;
    flex-shrink: 0;
}

.survey-runtime-inspector-title {
    font-family: Helvetica, Arial, sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: #333;
}

.survey-runtime-inspector-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #666;
    font-size: 16px;
    padding: 2px 4px;
    line-height: 1;
    outline: none;
}

.survey-runtime-inspector-close:hover {
    color: #222;
}

.survey-runtime-inspector-body {
    flex: 1;
    overflow-y: auto;
    padding: 12px;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 13px;
    color: #444;
}
.survey-runtime-inspector-empty {
    color: #999;
    font-style: italic;
}

.survey-runtime-inspector-field {
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
}

.survey-runtime-inspector-field:last-child {
    border-bottom: none;
}

.survey-runtime-inspector-field-name {
    font-weight: 600;
    color: #333;
    margin-bottom: 2px;
    word-break: break-all;
}

.survey-runtime-inspector-field-value {
    color: #555;
    word-break: break-all;
}

.survey-runtime-inspector-field-error {
    color: #c0392b;
    font-style: italic;
    word-break: break-all;
}
`, "",{"version":3,"sources":["webpack://./src/components/SurveyAdministration/SurveyRuntimeInspector/SurveyRuntimeInspector.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,yCAAyC;IACzC,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;IACb,yCAAyC;IACzC,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB","sourcesContent":[".survey-runtime-inspector {\n    position: fixed;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 5003;\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    pointer-events: none;\n}\n\n.survey-runtime-inspector-tab {\n    pointer-events: all;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    align-self: center;\n    background: var(--primary);\n    color: #fff;\n    border-radius: 0 4px 4px 0;\n    padding: 12px 6px;\n    cursor: pointer;\n    font-size: 12px;\n    font-family: Helvetica, Arial, sans-serif;\n    font-weight: 600;\n    letter-spacing: 0.05em;\n    white-space: nowrap;\n    writing-mode: vertical-rl;\n    text-orientation: mixed;\n    transform: rotate(180deg);\n    border: none;\n    outline: none;\n    user-select: none;\n    box-shadow: -2px 0 6px rgba(0, 0, 0, 0.2);\n}\n\n.survey-runtime-inspector-tab:hover {\n    background: var(--primary-hover);\n}\n\n.survey-runtime-inspector-panel {\n    pointer-events: all;\n    width: 300px;\n    background: #fff;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    box-shadow: -3px 0 10px rgba(0, 0, 0, 0.15);\n    overflow: hidden;\n}\n\n.survey-runtime-inspector-panel-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px;\n    border-bottom: 1px solid #e5e5e5;\n    flex-shrink: 0;\n}\n\n.survey-runtime-inspector-title {\n    font-family: Helvetica, Arial, sans-serif;\n    font-size: 13px;\n    font-weight: 600;\n    color: #333;\n}\n\n.survey-runtime-inspector-close {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #666;\n    font-size: 16px;\n    padding: 2px 4px;\n    line-height: 1;\n    outline: none;\n}\n\n.survey-runtime-inspector-close:hover {\n    color: #222;\n}\n\n.survey-runtime-inspector-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 12px;\n    font-family: Helvetica, Arial, sans-serif;\n    font-size: 13px;\n    color: #444;\n}\n.survey-runtime-inspector-empty {\n    color: #999;\n    font-style: italic;\n}\n\n.survey-runtime-inspector-field {\n    padding: 8px 0;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.survey-runtime-inspector-field:last-child {\n    border-bottom: none;\n}\n\n.survey-runtime-inspector-field-name {\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 2px;\n    word-break: break-all;\n}\n\n.survey-runtime-inspector-field-value {\n    color: #555;\n    word-break: break-all;\n}\n\n.survey-runtime-inspector-field-error {\n    color: #c0392b;\n    font-style: italic;\n    word-break: break-all;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
